module.exports = __webpack_public_path__ + "img/15.bc751ae9.jpg";